import { render } from "./BlogPageDetail.vue?vue&type=template&id=0092baae&scoped=true"
import script from "./BlogPageDetail.vue?vue&type=script&lang=js"
export * from "./BlogPageDetail.vue?vue&type=script&lang=js"

import "./BlogPageDetail.vue?vue&type=style&index=0&id=0092baae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0092baae"]])

export default __exports__